import {
  Container,
  Content,
  StyleEquipamentInfo,
  StyleMaintenanceInfo,
  StyledBoxBorder,
  StyledBoxContent,
  StyledBoxLeft,
  StyledClientInfo,
  StyledLocationLogo,
  StyledLocationLogoContainer,
  StyledPreventiveMaintenance,
} from '../styled';

const Unidades = ({ data }) => {
  return (
    <Container>
      <Content>
        <StyledBoxBorder>
          <StyledLocationLogoContainer>
            <StyledLocationLogo src={data.client.image} alt="Logo Cliente" />
          </StyledLocationLogoContainer>
          <StyledClientInfo>
            <div>
              <h2>{data.client.name}</h2>
              <h3>Saiba mais</h3>
            </div>
            <h4>Endereço</h4>
            <p>{data.client.address}</p>
            <h4>Telefone</h4>
            <p>{data.client.phone}</p>
          </StyledClientInfo>
          <StyleEquipamentInfo>
            <h2>Equipamento</h2>
            <div>
              <span></span>
              <span>
                <h3>Nome do equipamento</h3>
                <p>{data.equipment.name}</p>
                <h3>TAG</h3>
                <p>{data.equipment.tag}</p>
                <h3>Sistema</h3>
                <p>{data.equipment.system}</p>
              </span>
            </div>
          </StyleEquipamentInfo>
          <StyleMaintenanceInfo>
            <h2>Manutenção</h2>
            <h3>Possui ocorrências em aberto?</h3>
            <p>{data.maintenance.openOcurrence}</p>
            <h3>
              Tem Atividades Preventivas realizadas nos <br /> últimos 30 dias?
            </h3>
            <p>{data.maintenance.openPreventive}</p>
            <button>
              ABRIR SOLICITAÇÃO <span>(Em breve)</span>
            </button>
          </StyleMaintenanceInfo>
        </StyledBoxBorder>
        <StyledBoxLeft>
          <StyledBoxContent>
            <div>
              <h2>Especificações da Unidade</h2>
            </div>
            <div>
              <span>
                <h3>Quantidade de Áreas</h3>
                <p>{data.unit.areaQuantity}</p>
              </span>
              <span>
                <h3>Quantidade de Equipamentos</h3>
                <p>-</p>
              </span>
            </div>
          </StyledBoxContent>

          <StyledPreventiveMaintenance>
            <div>
              <span className="firstSpan">
                <h2>Maximize a eficiência em manutenção preventiva</h2>
                <p>Descubra como a Leankeep pode revolucionar sua gestão de manutenção preventiva.</p>
                <button>Saiba mais</button>
              </span>
              <span className="secondSpan"></span>
            </div>
          </StyledPreventiveMaintenance>
        </StyledBoxLeft>
      </Content>
    </Container>
  );
};

export default Unidades;
